import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { Alert, Box, CircularProgress, Container } from "@mui/material";
import { useRPMFrame } from "../hooks/useRPMFrame.js";
import { useAvatarUpdate } from "../hooks/useAvatarUpdate";
import { db } from "../firebase-config";
import {useEffect} from "react";

const RPM_API_KEY = process.env.REACT_APP_RPM_API_KEY;
const RPM_SUBDOMAIN = process.env.REACT_APP_RPM_SUBDOMAIN || "quizzler";

export default function AvatarEdit() {
    const { currentUser } = useAuth();
    const navigate = useNavigate();

    const { iframeLoaded, avatarUrl } = useRPMFrame(RPM_SUBDOMAIN, RPM_API_KEY);
    const { handleAvatarExported, loading, error, success } = useAvatarUpdate(db, currentUser, navigate);

    useEffect(() => {
        if (avatarUrl) {
            handleAvatarExported(avatarUrl);
        }
    }, [avatarUrl, handleAvatarExported]);

    if (!currentUser) {
        return <Navigate to="/" />;
    }

    return (
        <Container maxWidth={false} sx={{ maxWidth: "1500px !important", mx: "auto", py: 2 }}>
            <Box
                sx={{
                    position: "relative",
                    width: "100%",
                    height: "calc(100vh - 200px)",
                    minHeight: "700px",
                    border: 1,
                    borderColor: "divider",
                    borderRadius: 2,
                    overflow: "hidden",
                    mb: 1,
                    display: "flex",
                    flexDirection: "column",
                }}
            >
                {!iframeLoaded && (
                    <Box
                        sx={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            backgroundColor: "rgba(0,0,0,0.1)",
                            zIndex: 1,
                        }}
                    >
                        <CircularProgress />
                    </Box>
                )}
                <iframe
                    id="rpm-frame"
                    title="Ready Player Me"
                    className="rpm-frame"
                    style={{
                        width: "100%",
                        height: "100%",
                        border: "none",
                    }}
                    allow="camera *; microphone *; clipboard-write"
                />
            </Box>

            {loading && (
                <Box sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
                    <CircularProgress />
                </Box>
            )}

            {error && (
                <Alert severity="error" sx={{ mt: 2 }}>
                    {error}
                </Alert>
            )}

            {success && (
                <Alert severity="success" sx={{ mt: 2 }}>
                    {success}
                </Alert>
            )}
        </Container>
    );
}